module.exports = __webpack_public_path__ + "static/fugro-logo-8bc3f252329c2635c2c9c291120272c4.jpg";